import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { scrollDirection, scrollData } from './../redux/actions';

class PageWrapper extends Component {
  componentWillMount() {
    this.props.scroll_top('top');
    this.props.scroll_data({
      cat_menu_wrapper: null,
      portfolio_wrapper: null
    });
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <Fragment>
        {(this.props.staticContent) &&
          <main className={'page-wrap pop-in ' + this.props.pageId} id="top">
            {this.props.children}
          </main>
        }
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    staticContent: state.staticContent
  }),
  dispatch => ({
    scroll_top: (direction) => dispatch(scrollDirection(direction)),
    scroll_data: (scroll_state) => dispatch(scrollData(scroll_state))
  })
)(PageWrapper);



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js